<template>
  <div
    class="product-list-wrapper"
    :class="{ withoutBorder }"
    :style="{ backgroundColor: `var(--${bgColor})` }"
  >
    <div class="product-list">
      <div class="product-item " v-for="(product, i) in products" :key="i">
        <div class="product-image">
          <img :src="product.image">
        </div>
        <div class="product-info">
          <v-clamp class="product-name" autoresize :max-lines="2">{{ product.name }}</v-clamp>
          <div class="product-amount">Quantidade: {{
            product.amount >= 10
            ? product.amount
            : `0${product.amount}`
          }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VClamp from 'vue-clamp';

export default {
  components: { VClamp },
  name: 'product-list',
  props: {
    products: {
      type: Array,
    },
    withoutBorder: {
      type: Boolean,
      default: false,
    },
    bgColor: {
      type: String,
      default: 'white',
    },
  },
};
</script>

<style lang="scss" scoped>
.product-list-wrapper {
  background: var(--white);
  @media (min-width: $lg) {
    border: 1px solid var(--gray-300);
    box-sizing: border-box;
    border-radius: 4px;
    padding: 0 8px;
  }
  width: 100%;

  &.withoutBorder {
    border: 0;
  }
}

.product-list {
  box-sizing: border-box;
  width: 100%;
  padding: 8px 4px;
  @media (min-width: $lg) {
    max-height: 470px;
    overflow-y: scroll;
  }
}

.product-image {
  padding-right: 16px;
  img {
    width: 48px;
    height: 48px;
  }
}

.product-name {
  @extend .small-regular;
  @extend .gray-600;
}

.product-amount {
  @extend .small-regular;
  @extend .gray-400;
}

.product-item {
  padding: 12px 0 7px;
  display: flex;
  &:nth-child(n+2) {
    border-top: 1px solid var(--gray-300);
  }
}

</style>
